import { COUNTRY_ACTIONS } from './COUNTRY_ACTIONS'

export function countryReducer(state, action) {
  switch (action.type) {
    case COUNTRY_ACTIONS.SET_COUNTRY:
      return { ...state, country: action.payload.country }

    case COUNTRY_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}
